


















































import { Vue, Component } from 'vue-property-decorator'
import { mapActions, mapGetters } from 'vuex'
import navigate from '../libs/navigate'

@Component({
  computed: {
    ...mapGetters('Auth', ['isAuthenticated']),
    ...mapGetters('Accounts', ['emailCodeConfirmed'])
  },
  methods: {
    ...mapActions('Auth', ['login']),
    navigate: navigate
  }
})
export default class Login extends Vue {
  login!: (credentials: {}) => void // from the mapActions above
  isAuthenticated!: boolean // from the mapGetters above
  emailCodeConfirmed!: boolean // from the mapGetters above
  email = ''
  password = ''
  loading= false

  async submitLogin () {
    if (this.email !== '' && this.password !== '') {
      this.loading = true
      const { email, password } = this
      await new Promise(resolve => setTimeout(resolve, 1000))
      await this.login({ email, password })
      this.loading = false
    }
  }
}
